import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ScrollToTop from "../routes/scrollToTop"; // Import the ScrollToTop component

import '../css/root.css';

export default function Root() {
  return (
    <div>
      <Header />
      <ScrollToTop /> {/* Place it inside the Router tree */}
      <div className="MuiContainer-root">
        <div className="main-content-box">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}




// import React from "react";
// import { Outlet } from "react-router-dom";
// import Header from "../components/Header";  // Ensure correct import path
// import Footer from "../components/Footer";  // Ensure correct import path

// const Root = () => {
//   return (
//     <div>
//       <Header />
//       <Outlet />  {/* This renders child components */}
//       <Footer />
//     </div>
//   );
// };

// export default Root;
